



















import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  PickupCorporateSpecialHandlingLabel,
  PickupCorporateSpecialHandlingCode
} from '../PickupCorporateTable/index.types'

@Component({
  name: 'PickupCorporateSpecialHandlingBadges'
})
class PickupCorporateSpecialHandlingBadges extends Vue {
  @Prop({ type: String, required: true })
  readonly shipmentId!: string

  @Prop({ type: Array, required: true, default: () => [] })
  readonly badges!: PickupCorporateSpecialHandlingLabel[]

  get sortedBadges(): PickupCorporateSpecialHandlingLabel[] {
    const priorityOrder: Record<PickupCorporateSpecialHandlingCode, number> = {
      DG: 1,
      K: 2,
      KAYU: 3
    }

    return [...this.badges].sort((a, b) => {
      return (priorityOrder[a.code] || 99) - (priorityOrder[b.code] || 99)
    })
  }
}

export default PickupCorporateSpecialHandlingBadges
